import { INITIALIZE,TOGGLE_SUBSCRIPTION,SAVING_SUBSCRIPTION,UPDATED_SUBSCRIPTION } from '../actions/types';

const axios = require('axios');

export const initialize = (recipientUuid) => dispatch => {
    axios
    .post('email/stats/recipients',
    {
        "recipient_uuid": recipientUuid
    },
    {
        baseURL: process.env.REACT_APP_AR_COMMUNICATIONS_URL
    })
    .then(
        (result) => {
            var recipient = result.data[0];
            if(!recipient) {
                dispatch( {
                    type: INITIALIZE,
                    error: {
                        "message": "Invalid Link"
                    }
                });
            } else {
                dispatch( {
                    type: INITIALIZE,
                    recipient: recipient
                });
            }
        },
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        (error) => {
            dispatch( {
                type: INITIALIZE,
                error: {
                    "message": error
                }
            });
        }
    )
}

export const toggleSubscription = (isOptOut) => dispatch =>  {
    dispatch( {
        type: TOGGLE_SUBSCRIPTION,
        isOptOut: isOptOut
    });
}

export const saveSubscription = (recipient,isOptOut) => dispatch =>  {
    var endpoint;
    if(isOptOut) {
        endpoint = 'unsubscribe';
    } else {
        endpoint = 'resubscribe';
    }

    dispatch( {
        type: SAVING_SUBSCRIPTION,
        isOptOut: isOptOut
    });
    axios
      .post('email/' + endpoint,
      {
        "username": recipient.username,
        "email": recipient.email,
        "recipient_uuid": recipient.recipient_uuid
      },
      {
        baseURL: process.env.REACT_APP_AR_COMMUNICATIONS_URL
      })
      .then(
        (result) => {
            dispatch( {
                type: UPDATED_SUBSCRIPTION,
                updateSuccess: true
            });
        },
        
        (error) => {
            dispatch( {
                type: UPDATED_SUBSCRIPTION,
                updateSuccess: false
            });
      });
}